import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'vex-view-trademark-artwork',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatDividerModule, MatIconModule],
  templateUrl: './view-trademark-artwork.component.html',
  styleUrls: ['./view-trademark-artwork.component.scss']
})
export class ViewTrademarkArtworkComponent {
  images: any[] = [];
  tradeMarkReadme: string =
    'The licensee must submit the label to CQA, attaching the artwork to it (the user needs to download the artwork first, manually add it to the label, and then submit the label to CQA with the attached artwork).';

  constructor(@Inject(MAT_DIALOG_DATA) public data: { images: any }) {
    this.images = data?.images;

    this.images.forEach((image: any) => {
      if (image.file.endsWith('.svg')) {
        this.convertSvgToBase64(image.file).then((base64String: string) => {
          image.file = base64String;
        });
      }
    });
  }
  // Function to fetch SVG and convert it to Base64
  convertSvgToBase64(imageUrl: string): Promise<string> {
    return fetch(imageUrl)
      .then((response) => response.text())
      .then((svgText) => {
        const base64 = window.btoa(unescape(encodeURIComponent(svgText)));
        return `data:image/svg+xml;base64,${base64}`;
      });
  }

  defaultUserImage: string = 'assets/img/logo/error-loading.svg';
  // Set the source of the image to the default image path
  handleImageError(event: any) {
    event.target.src = this.defaultUserImage;
  }
}
